import PropTypes from 'prop-types';
import { Component, Children } from 'react';

class EnvironmentProvider extends Component {
  getChildContext() {
    return { environment: this.props.environment };
  }

  render() {
    return Children.only(this.props.children);
  }
}

EnvironmentProvider.propTypes = {
  environment: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
};

EnvironmentProvider.childContextTypes = {
  environment: PropTypes.object.isRequired,
};

export default EnvironmentProvider;



// WEBPACK FOOTER //
// ./app/components/environment-provider/environment-provider.js